import { useState } from 'react';
import { setupSeller, getSellerProfile, uploadStoreImage } from '../services/api';

export const useStoreSetup = () => {
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [error, setError] = useState(null);

  const setupStore = async (storeData) => {
    try {
      setLoading(true);
      setError(null);
      
      const result = await setupSeller(storeData);
      return result;
      
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleUploadStoreImage = async (userId, imageUri, imageType) => {
    try {
      setUploadLoading(true);
      setError(null);
      
      const result = await uploadStoreImage(userId, imageUri, imageType);
      return result;
      
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setUploadLoading(false);
    }
  };

  const fetchSellerProfile = async (userId) => {
    try {
      setLoading(true);
      setError(null);
      
      const result = await getSellerProfile(userId);
      return result;
      
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    setupStore,
    handleUploadStoreImage,
    fetchSellerProfile,
    loading,
    uploadLoading,
    error,
    clearError: () => setError(null)
  };
};